import { TableCell } from "~/shadcn/ui/table"
import { useCastingCall } from "./CastingCallRow"

export const SubmissionsCell = () => {
  const { castingCall } = useCastingCall()

  return <TableCell>{castingCall.submissionsCount}</TableCell>
}
